<template>
    <!-- 底部整条商品条 -->
    <div class="live-hot-bar">
        <div class="live-hot-bar__inner" @click="onClickCard" v-if="visible">
            <!-- 左侧商品图 + 左上角闪电标签 -->
            <div class="live-hot-bar__thumb">
                <img :src="product.image" alt="" />
                <div class="live-hot-bar__flash-tag">
                    <span class="live-hot-bar__flash-icon">⚡</span>
                    <!-- <span>{{ product.flashText }}</span> -->
                </div>
            </div>

            <!-- 中间信息区 -->
            <div class="live-hot-bar__info">
                <!-- 标题（单行省略号） -->
                <div class="live-hot-bar__title">
                    {{ product.title }}
                </div>

                <!-- 秒杀倒计时 + 额外折扣 -->
                <!-- <div class="live-hot-bar__meta-row">
                    <span class="meta-pill meta-pill--time">
                        ⚡ 直播秒杀 {{ product.countdown }}
                    </span>
                    <span class="meta-pill meta-pill--discount">
                        {{ product.extraDiscount }}
                    </span>
                </div> -->

                <!-- 运费、退货、保障标签 -->
                <!-- <div class="live-hot-bar__meta-row">
                    <span class="meta-pill meta-pill--plain" v-for="(tag, idx) in product.serviceTags" :key="idx">
                        {{ tag }}
                    </span>
                </div> -->

                <!-- 价格：当前价 + 划线价 + 折扣 -->
                <div class="live-hot-bar__price-row">
                    <span class="live-hot-bar__price-label">起始价格</span>
                    <span class="live-hot-bar__price-current">
                        ${{ product.priceCurrent }}
                    </span>
                    <!-- <span class="live-hot-bar__price-origin">
                        ${{ product.priceOrigin }}
                    </span>
                    <span class="live-hot-bar__price-off">
                        -{{ product.priceOff }}
                    </span> -->
                    <!-- 右侧“购买”按钮 -->
                    <button class="live-hot-bar__buy" @click.stop="onClickBuy">
                        buy
                    </button>
                </div>
            </div>

            <!-- 右上角关闭 -->
            <button class="live-hot-bar__close" @click.stop="$emit('close')">
                ✕
            </button>
        </div>

        <!-- 左下角购物车/购物袋图标（仿“99+”） -->
        <div class="live-hot-bar__cart" @click="onClickCart">
            <div class="live-hot-bar__cart-icon">
                <img src="../assets/cart.svg" style="width: 35px; height: 35px;top: 2px;position: relative;" />
            </div>
            <!-- <div class="live-hot-bar__cart-badge" v-if="cartCount > 0">
        {{ cartCount > 99 ? '99+' : cartCount }}
      </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'LiveHotProductBar',
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        product: {
            type: Object,
            default: () => ({
                // image: '',
                // flashText: '5剩余',
                // title: 'Women\'s Faux Fur Coat, Winter Fashion Long...',
                // countdown: '00:06:38',
                // extraDiscount: '10% 额外折扣',
                // serviceTags: ['免邮配送', '免费退货', '退款保障'],
                // priceCurrent: '71.48',
                // priceOrigin: '124.69',
                // priceOff: '43%'
            })
        },
        cartCount: {
            type: Number,
            default: 0
        }
    },
    methods: {
        onClickBuy() {
            this.$emit('buy', this.product)
        },
        onClickCard() {
            this.$emit('view', this.product)
        },
        onClickCart() {
            // this.$emit('open-cart')
            this.$emit('open-list')
            // this.$emit('buy', item)
            // this.$emit('update:visible',true)
        }
    }
}
</script>

<style scoped>
/* 整体容器：紧贴底部，宽度占满直播画面 */
.live-hot-bar {
    position: relative;
    /* left: 0;
  right: 0;
  bottom: 70px; */
    padding: 0 8px;
    z-index: 30;
    pointer-events: none;
    /* 先禁用，再给内部开启点击 */
}

/* 白色主卡片 */
.live-hot-bar__inner {
    pointer-events: auto;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    padding: 8px;
    position: absolute;
    top: -90px;
    width: calc(100vw - 24px);
}

/* 左侧图 */
.live-hot-bar__thumb {
    width: 72px;
    height: 72px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    flex-shrink: 0;
}

.live-hot-bar__thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 左上角闪电标签 */
.live-hot-bar__flash-tag {
    position: absolute;
    left: 0;
    top: 0;
    padding: 2px 6px;
    border-bottom-right-radius: 8px;
    background: linear-gradient(90deg, #ff6b00, #ff3b30);
    color: #fff;
    font-size: 10px;
    display: inline-flex;
    align-items: center;
}

.live-hot-bar__flash-icon {
    margin-right: 2px;
}

/* 中部信息区 */
.live-hot-bar__info {
    flex: 1;
    margin-left: 8px;
    display: flex;
    flex-direction: column;
}

/* 标题，单行省略 */
.live-hot-bar__title {
    font-size: 12px;
    font-weight: 600;
    color: #222;
    line-height: 1.4;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;
}

/* 上下两行 meta pill 行 */
.live-hot-bar__meta-row {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 3px;
}

.meta-pill {
    padding: 0 6px;
    border-radius: 10px;
    font-size: 10px;
    line-height: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
}

.meta-pill--time {
    background: rgba(255, 138, 0, 0.12);
    color: #ff6200;
}

.meta-pill--discount {
    background: rgba(255, 59, 48, 0.12);
    color: #ff3b30;
}

.meta-pill--plain {
    background: #f5f5f5;
    color: #666;
}

/* 价格行 */
.live-hot-bar__price-row {
    margin-top: 2px;
    display: flex;
    align-items: baseline;
    gap: 4px;
}

.live-hot-bar__price-label {
    font-size: 10px;
    color: #666;
}

.live-hot-bar__price-current {
    font-size: 16px;
    font-weight: 700;
    color: #222;
}

.live-hot-bar__price-origin {
    font-size: 11px;
    color: #999;
    text-decoration: line-through;
}

.live-hot-bar__price-off {
    font-size: 11px;
    color: #ffffff;
    background: #ff3b30;
    border-radius: 8px;
    padding: 0 6px;
}

/* 右侧按钮区域 */
.live-hot-bar__action {
    margin-left: 8px;
    /* flex-shrink: 0; */
    width: 60px;
    height: 30px;
}

.live-hot-bar__buy {
    border: none;
    outline: none;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(135deg, #ff6b00, #ff3b30);
    padding: 1px 14px;
    border-radius: 5px;
}

/* 右上关闭按钮 */
.live-hot-bar__close {
    position: absolute;
    right: 4px;
    top: 4px;
    border: none;
    outline: none;
    background: transparent;
    font-size: 12px;
    color: #999;
    padding: 2px;
}

/* 左下购物袋 */
.live-hot-bar__cart {
    pointer-events: auto;
}

.live-hot-bar__cart-icon {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    /* background: #ff7a00; */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 22px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.live-hot-bar__cart-badge {
    position: absolute;
    right: -4px;
    top: -4px;
    min-width: 18px;
    height: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background: #ff3b30;
    color: #fff;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
